interface CountryType {
  code: string;
  label: string;
  suggested?: boolean;
}

export const getFlagUrl = (code: string, size: "20" | "40" = "20") =>
  `https://flagcdn.com/w${size}/${code.toLowerCase()}.png`;

// From https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
export const countries: readonly CountryType[] = [
  { code: "AD", label: "Andorra" },
  {
    code: "AE",
    label: "United Arab Emirates",
  },
  { code: "AF", label: "Afghanistan" },
  {
    code: "AG",
    label: "Antigua and Barbuda",
  },
  { code: "AI", label: "Anguilla" },
  { code: "AL", label: "Albania" },
  { code: "AM", label: "Armenia" },
  { code: "AO", label: "Angola" },
  { code: "AQ", label: "Antarctica" },
  { code: "AR", label: "Argentina" },
  { code: "AS", label: "American Samoa" },
  { code: "AT", label: "Austria" },
  {
    code: "AU",
    label: "Australia",
    suggested: true,
  },
  { code: "AW", label: "Aruba" },
  { code: "AX", label: "Alland Islands" },
  { code: "AZ", label: "Azerbaijan" },
  {
    code: "BA",
    label: "Bosnia and Herzegovina",
  },
  { code: "BB", label: "Barbados" },
  { code: "BD", label: "Bangladesh" },
  { code: "BE", label: "Belgium" },
  { code: "BF", label: "Burkina Faso" },
  { code: "BG", label: "Bulgaria" },
  { code: "BH", label: "Bahrain" },
  { code: "BI", label: "Burundi" },
  { code: "BJ", label: "Benin" },
  { code: "BL", label: "Saint Barthelemy" },
  { code: "BM", label: "Bermuda" },
  { code: "BN", label: "Brunei Darussalam" },
  { code: "BO", label: "Bolivia" },
  { code: "BR", label: "Brazil" },
  { code: "BS", label: "Bahamas" },
  { code: "BT", label: "Bhutan" },
  { code: "BV", label: "Bouvet Island" },
  { code: "BW", label: "Botswana" },
  { code: "BY", label: "Belarus" },
  { code: "BZ", label: "Belize" },
  {
    code: "CA",
    label: "Canada",

    suggested: true,
  },
  {
    code: "CC",
    label: "Cocos (Keeling) Islands",
  },
  {
    code: "CD",
    label: "Congo, Democratic Republic of the",
  },
  {
    code: "CF",
    label: "Central African Republic",
  },
  {
    code: "CG",
    label: "Congo, Republic of the",
  },
  { code: "CH", label: "Switzerland" },
  { code: "CI", label: "Cote d'Ivoire" },
  { code: "CK", label: "Cook Islands" },
  { code: "CL", label: "Chile" },
  { code: "CM", label: "Cameroon" },
  { code: "CN", label: "China" },
  { code: "CO", label: "Colombia" },
  { code: "CR", label: "Costa Rica" },
  { code: "CU", label: "Cuba" },
  { code: "CV", label: "Cape Verde" },
  { code: "CW", label: "Curacao" },
  { code: "CX", label: "Christmas Island" },
  { code: "CY", label: "Cyprus" },
  { code: "CZ", label: "Czech Republic" },
  {
    code: "DE",
    label: "Germany",

    suggested: true,
  },
  { code: "DJ", label: "Djibouti" },
  { code: "DK", label: "Denmark" },
  { code: "DM", label: "Dominica" },
  {
    code: "DO",
    label: "Dominican Republic",
  },
  { code: "DZ", label: "Algeria" },
  { code: "EC", label: "Ecuador" },
  { code: "EE", label: "Estonia" },
  { code: "EG", label: "Egypt" },
  { code: "EH", label: "Western Sahara" },
  { code: "ER", label: "Eritrea" },
  { code: "ES", label: "Spain" },
  { code: "ET", label: "Ethiopia" },
  { code: "FI", label: "Finland" },
  { code: "FJ", label: "Fiji" },
  {
    code: "FK",
    label: "Falkland Islands (Malvinas)",
  },
  {
    code: "FM",
    label: "Micronesia, Federated States of",
  },
  { code: "FO", label: "Faroe Islands" },
  {
    code: "FR",
    label: "France",

    suggested: true,
  },
  { code: "GA", label: "Gabon" },
  { code: "GB", label: "United Kingdom" },
  { code: "GD", label: "Grenada" },
  { code: "GE", label: "Georgia" },
  { code: "GF", label: "French Guiana" },
  { code: "GG", label: "Guernsey" },
  { code: "GH", label: "Ghana" },
  { code: "GI", label: "Gibraltar" },
  { code: "GL", label: "Greenland" },
  { code: "GM", label: "Gambia" },
  { code: "GN", label: "Guinea" },
  { code: "GP", label: "Guadeloupe" },
  { code: "GQ", label: "Equatorial Guinea" },
  { code: "GR", label: "Greece" },
  {
    code: "GS",
    label: "South Georgia and the South Sandwich Islands",
  },
  { code: "GT", label: "Guatemala" },
  { code: "GU", label: "Guam" },
  { code: "GW", label: "Guinea-Bissau" },
  { code: "GY", label: "Guyana" },
  { code: "HK", label: "Hong Kong" },
  {
    code: "HM",
    label: "Heard Island and McDonald Islands",
  },
  { code: "HN", label: "Honduras" },
  { code: "HR", label: "Croatia" },
  { code: "HT", label: "Haiti" },
  { code: "HU", label: "Hungary" },
  { code: "ID", label: "Indonesia" },
  { code: "IE", label: "Ireland" },
  { code: "IL", label: "Israel" },
  { code: "IM", label: "Isle of Man" },
  { code: "IN", label: "India" },
  {
    code: "IO",
    label: "British Indian Ocean Territory",
  },
  { code: "IQ", label: "Iraq" },
  {
    code: "IR",
    label: "Iran, Islamic Republic of",
  },
  { code: "IS", label: "Iceland" },
  { code: "IT", label: "Italy" },
  { code: "JE", label: "Jersey" },
  { code: "JM", label: "Jamaica" },
  { code: "JO", label: "Jordan" },
  {
    code: "JP",
    label: "Japan",

    suggested: true,
  },
  { code: "KE", label: "Kenya" },
  { code: "KG", label: "Kyrgyzstan" },
  { code: "KH", label: "Cambodia" },
  { code: "KI", label: "Kiribati" },
  { code: "KM", label: "Comoros" },
  {
    code: "KN",
    label: "Saint Kitts and Nevis",
  },
  {
    code: "KP",
    label: "Korea, Democratic People's Republic of",
  },
  { code: "KR", label: "Korea, Republic of" },
  { code: "KW", label: "Kuwait" },
  { code: "KY", label: "Cayman Islands" },
  { code: "KZ", label: "Kazakhstan" },
  {
    code: "LA",
    label: "Lao People's Democratic Republic",
  },
  { code: "LB", label: "Lebanon" },
  { code: "LC", label: "Saint Lucia" },
  { code: "LI", label: "Liechtenstein" },
  { code: "LK", label: "Sri Lanka" },
  { code: "LR", label: "Liberia" },
  { code: "LS", label: "Lesotho" },
  { code: "LT", label: "Lithuania" },
  { code: "LU", label: "Luxembourg" },
  { code: "LV", label: "Latvia" },
  { code: "LY", label: "Libya" },
  { code: "MA", label: "Morocco" },
  { code: "MC", label: "Monaco" },
  {
    code: "MD",
    label: "Moldova, Republic of",
  },
  { code: "ME", label: "Montenegro" },
  {
    code: "MF",
    label: "Saint Martin (French part)",
  },
  { code: "MG", label: "Madagascar" },
  { code: "MH", label: "Marshall Islands" },
  {
    code: "MK",
    label: "Macedonia, the Former Yugoslav Republic of",
  },
  { code: "ML", label: "Mali" },
  { code: "MM", label: "Myanmar" },
  { code: "MN", label: "Mongolia" },
  { code: "MO", label: "Macao" },
  {
    code: "MP",
    label: "Northern Mariana Islands",
  },
  { code: "MQ", label: "Martinique" },
  { code: "MR", label: "Mauritania" },
  { code: "MS", label: "Montserrat" },
  { code: "MT", label: "Malta" },
  { code: "MU", label: "Mauritius" },
  { code: "MV", label: "Maldives" },
  { code: "MW", label: "Malawi" },
  { code: "MX", label: "Mexico" },
  { code: "MY", label: "Malaysia" },
  { code: "MZ", label: "Mozambique" },
  { code: "NA", label: "Namibia" },
  { code: "NC", label: "New Caledonia" },
  { code: "NE", label: "Niger" },
  { code: "NF", label: "Norfolk Island" },
  { code: "NG", label: "Nigeria" },
  { code: "NI", label: "Nicaragua" },
  { code: "NL", label: "Netherlands" },
  { code: "NO", label: "Norway" },
  { code: "NP", label: "Nepal" },
  { code: "NR", label: "Nauru" },
  { code: "NU", label: "Niue" },
  { code: "NZ", label: "New Zealand" },
  { code: "OM", label: "Oman" },
  { code: "PA", label: "Panama" },
  { code: "PE", label: "Peru" },
  { code: "PF", label: "French Polynesia" },
  { code: "PG", label: "Papua New Guinea" },
  { code: "PH", label: "Philippines" },
  { code: "PK", label: "Pakistan" },
  { code: "PL", label: "Poland" },
  {
    code: "PM",
    label: "Saint Pierre and Miquelon",
  },
  { code: "PN", label: "Pitcairn" },
  { code: "PR", label: "Puerto Rico" },
  {
    code: "PS",
    label: "Palestine, State of",
  },
  { code: "PT", label: "Portugal" },
  { code: "PW", label: "Palau" },
  { code: "PY", label: "Paraguay" },
  { code: "QA", label: "Qatar" },
  { code: "RE", label: "Reunion" },
  { code: "RO", label: "Romania" },
  { code: "RS", label: "Serbia" },
  { code: "RU", label: "Russian Federation" },
  { code: "RW", label: "Rwanda" },
  { code: "SA", label: "Saudi Arabia" },
  { code: "SB", label: "Solomon Islands" },
  { code: "SC", label: "Seychelles" },
  { code: "SD", label: "Sudan" },
  { code: "SE", label: "Sweden" },
  { code: "SG", label: "Singapore" },
  { code: "SH", label: "Saint Helena" },
  { code: "SI", label: "Slovenia" },
  {
    code: "SJ",
    label: "Svalbard and Jan Mayen",
  },
  { code: "SK", label: "Slovakia" },
  { code: "SL", label: "Sierra Leone" },
  { code: "SM", label: "San Marino" },
  { code: "SN", label: "Senegal" },
  { code: "SO", label: "Somalia" },
  { code: "SR", label: "Suriname" },
  { code: "SS", label: "South Sudan" },
  {
    code: "ST",
    label: "Sao Tome and Principe",
  },
  { code: "SV", label: "El Salvador" },
  {
    code: "SX",
    label: "Sint Maarten (Dutch part)",
  },
  {
    code: "SY",
    label: "Syrian Arab Republic",
  },
  { code: "SZ", label: "Swaziland" },
  {
    code: "TC",
    label: "Turks and Caicos Islands",
  },
  { code: "TD", label: "Chad" },
  {
    code: "TF",
    label: "French Southern Territories",
  },
  { code: "TG", label: "Togo" },
  { code: "TH", label: "Thailand" },
  { code: "TJ", label: "Tajikistan" },
  { code: "TK", label: "Tokelau" },
  { code: "TL", label: "Timor-Leste" },
  { code: "TM", label: "Turkmenistan" },
  { code: "TN", label: "Tunisia" },
  { code: "TO", label: "Tonga" },
  { code: "TR", label: "Turkey" },
  {
    code: "TT",
    label: "Trinidad and Tobago",
  },
  { code: "TV", label: "Tuvalu" },
  {
    code: "TW",
    label: "Taiwan",
  },
  {
    code: "TZ",
    label: "United Republic of Tanzania",
  },
  { code: "UA", label: "Ukraine" },
  { code: "UG", label: "Uganda" },
  {
    code: "US",
    label: "United States",

    suggested: true,
  },
  { code: "UY", label: "Uruguay" },
  { code: "UZ", label: "Uzbekistan" },
  {
    code: "VA",
    label: "Holy See (Vatican City State)",
  },
  {
    code: "VC",
    label: "Saint Vincent and the Grenadines",
  },
  { code: "VE", label: "Venezuela" },
  {
    code: "VG",
    label: "British Virgin Islands",
  },
  {
    code: "VI",
    label: "US Virgin Islands",
  },
  { code: "VN", label: "Vietnam" },
  { code: "VU", label: "Vanuatu" },
  { code: "WF", label: "Wallis and Futuna" },
  { code: "WS", label: "Samoa" },
  { code: "XK", label: "Kosovo" },
  { code: "YE", label: "Yemen" },
  { code: "YT", label: "Mayotte" },
  { code: "ZA", label: "South Africa" },
  { code: "ZM", label: "Zambia" },
  { code: "ZW", label: "Zimbabwe" },
];

export const frenchCountries: readonly CountryType[] = [
  { code: "AD", label: "Andorre" },
  { code: "AE", label: "Émirats Arabes Unis" },
  { code: "AF", label: "Afghanistan" },
  { code: "AG", label: "Antigua-et-Barbuda" },
  { code: "AI", label: "Anguilla" },
  { code: "AL", label: "Albanie" },
  { code: "AM", label: "Arménie" },
  { code: "AO", label: "Angola" },
  { code: "AQ", label: "Antarctique" },
  { code: "AR", label: "Argentine" },
  { code: "AS", label: "Samoa américaines" },
  { code: "AT", label: "Autriche" },
  { code: "AU", label: "Australie", suggested: true },
  { code: "AW", label: "Aruba" },
  { code: "AX", label: "Îles Åland" },
  { code: "AZ", label: "Azerbaïdjan" },
  { code: "BA", label: "Bosnie-Herzégovine" },
  { code: "BB", label: "Barbade" },
  { code: "BD", label: "Bangladesh" },
  { code: "BE", label: "Belgique" },
  { code: "BF", label: "Burkina Faso" },
  { code: "BG", label: "Bulgarie" },
  { code: "BH", label: "Bahreïn" },
  { code: "BI", label: "Burundi" },
  { code: "BJ", label: "Bénin" },
  { code: "BL", label: "Saint-Barthélemy" },
  { code: "BM", label: "Bermudes" },
  { code: "BN", label: "Brunéi Darussalam" },
  { code: "BO", label: "Bolivie" },
  { code: "BR", label: "Brésil" },
  { code: "BS", label: "Bahamas" },
  { code: "BT", label: "Bhoutan" },
  { code: "BV", label: "Île Bouvet" },
  { code: "BW", label: "Botswana" },
  { code: "BY", label: "Biélorussie" },
  { code: "BZ", label: "Belize" },
  { code: "CA", label: "Canada", suggested: true },
  { code: "CC", label: "Îles Cocos (Keeling)" },
  { code: "CD", label: "République démocratique du Congo" },
  { code: "CF", label: "République centrafricaine" },
  { code: "CG", label: "République du Congo" },
  { code: "CH", label: "Suisse" },
  { code: "CI", label: "Côte d'Ivoire" },
  { code: "CK", label: "Îles Cook" },
  { code: "CL", label: "Chili" },
  { code: "CM", label: "Cameroun" },
  { code: "CN", label: "Chine" },
  { code: "CO", label: "Colombie" },
  { code: "CR", label: "Costa Rica" },
  { code: "CU", label: "Cuba" },
  { code: "CV", label: "Cap-Vert" },
  { code: "CW", label: "Curaçao" },
  { code: "CX", label: "Île Christmas" },
  { code: "CY", label: "Chypre" },
  { code: "CZ", label: "République tchèque" },
  { code: "DE", label: "Allemagne", suggested: true },
  { code: "DJ", label: "Djibouti" },
  { code: "DK", label: "Danemark" },
  { code: "DM", label: "Dominique" },
  { code: "DO", label: "République dominicaine" },
  { code: "DZ", label: "Algérie" },
  { code: "EC", label: "Équateur" },
  { code: "EE", label: "Estonie" },
  { code: "EG", label: "Égypte" },
  { code: "EH", label: "Sahara occidental" },
  { code: "ER", label: "Érythrée" },
  { code: "ES", label: "Espagne" },
  { code: "ET", label: "Éthiopie" },
  { code: "FI", label: "Finlande" },
  { code: "FJ", label: "Fidji" },
  { code: "FK", label: "Îles Falkland (Malvinas)" },
  { code: "FM", label: "États fédérés de Micronésie" },
  { code: "FO", label: "Îles Féroé" },
  { code: "FR", label: "France", suggested: true },
  { code: "GA", label: "Gabon" },
  { code: "GB", label: "Royaume-Uni" },
  { code: "GD", label: "Grenade" },
  { code: "GE", label: "Géorgie" },
  { code: "GF", label: "Guyane française" },
  { code: "GG", label: "Guernesey" },
  { code: "GH", label: "Ghana" },
  { code: "GI", label: "Gibraltar" },
  { code: "GL", label: "Groenland" },
  { code: "GM", label: "Gambie" },
  { code: "GN", label: "Guinée" },
  { code: "GP", label: "Guadeloupe" },
  { code: "GQ", label: "Guinée équatoriale" },
  { code: "GR", label: "Grèce" },
  { code: "GS", label: "Géorgie du Sud et les îles Sandwich du Sud" },
  { code: "GT", label: "Guatemala" },
  { code: "GU", label: "Guam" },
  { code: "GW", label: "Guinée-Bissau" },
  { code: "GY", label: "Guyana" },
  { code: "HK", label: "Hong Kong" },
  { code: "HM", label: "Îles Heard et McDonald" },
  { code: "HN", label: "Honduras" },
  { code: "HR", label: "Croatie" },
  { code: "HT", label: "Haïti" },
  { code: "HU", label: "Hongrie" },
  { code: "ID", label: "Indonésie" },
  { code: "IE", label: "Irlande" },
  { code: "IL", label: "Israël" },
  { code: "IM", label: "Île de Man" },
  { code: "IN", label: "Inde" },
  { code: "IO", label: "Territoire britannique de l'océan Indien" },
  { code: "IQ", label: "Irak" },
  { code: "IR", label: "Iran" },
  { code: "IS", label: "Islande" },
  { code: "IT", label: "Italie" },
  { code: "JE", label: "Jersey" },
  { code: "JM", label: "Jamaïque" },
  { code: "JO", label: "Jordanie" },
  { code: "JP", label: "Japon", suggested: true },
  { code: "KE", label: "Kenya" },
  { code: "KG", label: "Kirghizistan" },
  { code: "KH", label: "Cambodge" },
  { code: "KI", label: "Kiribati" },
  { code: "KM", label: "Comores" },
  { code: "KN", label: "Saint-Christophe-et-Niévès" },
  { code: "KP", label: "Corée du Nord" },
  { code: "KR", label: "Corée du Sud" },
  { code: "KW", label: "Koweït" },
  { code: "KY", label: "Îles Caïmans" },
  { code: "KZ", label: "Kazakhstan" },
  { code: "LA", label: "Laos" },
  { code: "LB", label: "Liban" },
  { code: "LC", label: "Sainte-Lucie" },
  { code: "LI", label: "Liechtenstein" },
  { code: "LK", label: "Sri Lanka" },
  { code: "LR", label: "Libéria" },
  { code: "LS", label: "Lesotho" },
  { code: "LT", label: "Lituanie" },
  { code: "LU", label: "Luxembourg" },
  { code: "LV", label: "Lettonie" },
  { code: "LY", label: "Libye" },
  { code: "MA", label: "Maroc" },
  { code: "MC", label: "Monaco" },
  { code: "MD", label: "Moldavie" },
  { code: "ME", label: "Monténégro" },
  { code: "MF", label: "Saint-Martin (partie française)" },
  { code: "MG", label: "Madagascar" },
  { code: "MH", label: "Îles Marshall" },
  { code: "MK", label: "Macédoine du Nord" },
  { code: "ML", label: "Mali" },
  { code: "MM", label: "Myanmar" },
  { code: "MN", label: "Mongolie" },
  { code: "MO", label: "Macao" },
  { code: "MP", label: "Îles Mariannes du Nord" },
  { code: "MQ", label: "Martinique" },
  { code: "MR", label: "Mauritanie" },
  { code: "MS", label: "Montserrat" },
  { code: "MT", label: "Malte" },
  { code: "MU", label: "Maurice" },
  { code: "MV", label: "Maldives" },
  { code: "MW", label: "Malawi" },
  { code: "MX", label: "Mexique" },
  { code: "MY", label: "Malaisie" },
  { code: "MZ", label: "Mozambique" },
  { code: "NA", label: "Namibie" },
  { code: "NC", label: "Nouvelle-Calédonie" },
  { code: "NE", label: "Niger" },
  { code: "NF", label: "Île Norfolk" },
  { code: "NG", label: "Nigéria" },
  { code: "NI", label: "Nicaragua" },
  { code: "NL", label: "Pays-Bas" },
  { code: "NO", label: "Norvège" },
  { code: "NP", label: "Népal" },
  { code: "NR", label: "Nauru" },
  { code: "NU", label: "Niue" },
  { code: "NZ", label: "Nouvelle-Zélande" },
  { code: "OM", label: "Oman" },
  { code: "PA", label: "Panama" },
  { code: "PE", label: "Pérou" },
  { code: "PF", label: "Polynésie française" },
  { code: "PG", label: "Papouasie-Nouvelle-Guinée" },
  { code: "PH", label: "Philippines" },
  { code: "PK", label: "Pakistan" },
  { code: "PL", label: "Pologne" },
  { code: "PM", label: "Saint-Pierre-et-Miquelon" },
  { code: "PN", label: "Pitcairn" },
  { code: "PR", label: "Porto Rico" },
  { code: "PS", label: "Palestine" },
  { code: "PT", label: "Portugal" },
  { code: "PW", label: "Palaos" },
  { code: "PY", label: "Paraguay" },
  { code: "QA", label: "Qatar" },
  { code: "RE", label: "Réunion" },
  { code: "RO", label: "Roumanie" },
  { code: "RS", label: "Serbie" },
  { code: "RU", label: "Russie" },
  { code: "RW", label: "Rwanda" },
  { code: "SA", label: "Arabie saoudite" },
  { code: "SB", label: "Îles Salomon" },
  { code: "SC", label: "Seychelles" },
  { code: "SD", label: "Soudan" },
  { code: "SE", label: "Suède" },
  { code: "SG", label: "Singapour" },
  { code: "SH", label: "Sainte-Hélène" },
  { code: "SI", label: "Slovénie" },
  { code: "SJ", label: "Svalbard et Jan Mayen" },
  { code: "SK", label: "Slovaquie" },
  { code: "SL", label: "Sierra Leone" },
  { code: "SM", label: "Saint-Marin" },
  { code: "SN", label: "Sénégal" },
  { code: "SO", label: "Somalie" },
  { code: "SR", label: "Suriname" },
  { code: "SS", label: "Soudan du Sud" },
  { code: "ST", label: "Sao Tomé-et-Principe" },
  { code: "SV", label: "Salvador" },
  { code: "SX", label: "Saint-Martin (partie néerlandaise)" },
  { code: "SY", label: "Syrie" },
  { code: "SZ", label: "Eswatini" },
  { code: "TC", label: "Îles Turques-et-Caïques" },
  { code: "TD", label: "Tchad" },
  { code: "TF", label: "Terres australes françaises" },
  { code: "TG", label: "Togo" },
  { code: "TH", label: "Thaïlande" },
  { code: "TJ", label: "Tadjikistan" },
  { code: "TK", label: "Tokelau" },
  { code: "TL", label: "Timor-Leste" },
  { code: "TM", label: "Turkménistan" },
  { code: "TN", label: "Tunisie" },
  { code: "TO", label: "Tonga" },
  { code: "TR", label: "Turquie" },
  { code: "TT", label: "Trinité-et-Tobago" },
  { code: "TV", label: "Tuvalu" },
  { code: "TW", label: "Taïwan" },
  { code: "TZ", label: "Tanzanie" },
  { code: "UA", label: "Ukraine" },
  { code: "UG", label: "Ouganda" },
  { code: "US", label: "États-Unis", suggested: true },
  { code: "UY", label: "Uruguay" },
  { code: "UZ", label: "Ouzbékistan" },
  { code: "VA", label: "Vatican" },
  { code: "VC", label: "Saint-Vincent-et-les-Grenadines" },
  { code: "VE", label: "Venezuela" },
  { code: "VG", label: "Îles Vierges britanniques" },
  { code: "VI", label: "Îles Vierges américaines" },
  { code: "VN", label: "Vietnam" },
  { code: "VU", label: "Vanuatu" },
  { code: "WF", label: "Wallis-et-Futuna" },
  { code: "WS", label: "Samoa" },
  { code: "XK", label: "Kosovo" },
  { code: "YE", label: "Yémen" },
  { code: "YT", label: "Mayotte" },
  { code: "ZA", label: "Afrique du Sud" },
  { code: "ZM", label: "Zambie" },
  { code: "ZW", label: "Zimbabwe" },
];
